import { FaComments, FaPalette, FaBoxes, FaCheckCircle, FaPrint,
  FaTruck
} from "react-icons/fa";
import images from "./images";

const process = [
  {
    id: 1,
    icon: <FaComments />, // Comments icon
    image: images.step1,
    title: 'Initial Consultation',
    content: 'Start with a detailed discussion to understand your printing requirements, brand identity, and preferred styles or finishes.',
  },
  {
    id: 2,
    icon: <FaPalette />, // Palette icon
    image: images.step2,
    title: 'Design & Concept',
    content: 'Our team creates custom design concepts tailored to your vision, whether it’s for flyers, business cards, or packaging.',
  },
  {
    id: 3,
    icon: <FaBoxes />, // Boxes icon
    image: images.step3,
    title: 'Material Selection',
    content: 'Choose from a wide range of paper stocks, inks, laminations, and finishes to achieve the look and feel you desire.',
  },
  {
    id: 4,
    icon: <FaCheckCircle />, // CheckCircle icon
    image: images.step4,
    title: 'Proofing & Revisions',
    content: 'Review design proofs and suggest changes. We’ll revise until the final layout meets your complete satisfaction.',
  },
  {
    id: 5,
    icon: <FaPrint />, // Print icon
    image: images.step5,
    title: 'Printing & Production',
    content: 'We bring your designs to life using high-quality printing technology, ensuring color accuracy and sharp detail.',
  },
  {
    id: 6,
    icon: <FaTruck />, // Truck icon
    image: images.step6,
    title: 'Delivery & Handover',
    content: 'Your printed products are packed with care and delivered on time, ready to impress and make an impact.',
  },
];

export default process;
